<template>
  <div class="page-partners">
    <div class="page-partners__container" v-for="partner in filteredPartners" :key="partner.id">
      <partners-link
        :partner="partner"
        :currentPartner="currentPartner"
        :value="partner.id"
        @on-change-partner="onChangeActivePartner"/>
    </div>

    <div v-show="isShowMore">
        <div class="page-partners__container" v-for="partner in filteredPartnersShowMore" :key="partner.id">
          <partners-link
            :partner="partner"
            :currentPartner="currentPartner"
            :value="partner.id"
            @on-change-partner="onChangeActivePartner"/>
        </div>
    </div>

    <div v-if="partners && partners.length > 8" class="page-partners__show-more">
        <span class="page-partners__show-more-items" @click="showMore">
          Показать больше
             <IconChevronDown
               :class="isShowMore ? 'show-open' : ''"
             />
        </span>
    </div>
  </div>
</template>

<script>
import IconChevronDown from '../../icons/icon-chevron-down'
import PartnersLink from "./partners-link";

export default {
  name: 'partners',
  components: {
    PartnersLink,
    IconChevronDown
  },

  computed: {
    filteredPartners() {
      const newItems = this.partners.slice()
      return newItems.filter((p, ind) => ind <= 8 )
    },

    filteredPartnersShowMore() {
      const newItems = this.partners.slice()
      return newItems.filter((p, ind) => ind > 8 )
    }
  },

  props: {
    partners: { type: Array, default: () => [], required: false },
  },

  data() {
    return {
      currentPartner: null,
      isShowMore: false,
    }
  },

  methods: {
    showMore() {
      this.isShowMore = !this.isShowMore
    },

    onChangeActivePartner(partnerId) {
      this.currentPartner = partnerId
      this.$emit('on-change-active-partner', partnerId)
    }
  },
}
</script>
